import { __assign, __rest } from "tslib";
import React, { useState, useEffect, } from 'react';
import { GALLERY_CONSTS, ProGallery } from 'pro-gallery';
import { callServerToGetUrls, processItems, converItemsToProGalleryItems } from './itemsProcessor';
import { getResizeMediaUrl, TPADimensionsHelper, } from '@wix/photography-client-lib';
import { LayoutFixer } from '@wix/pro-gallery-layout-fixer';
import optionsConverter from './proGalleryOptionsBuilder';
import { processLayouts, addPresetOptions, extendNestedOptionsToIncludeOldAndNew, } from 'pro-gallery-lib';
import FullscreenWrapper from './components/fullscreen/fullscreenWrapper';
import { InfoElement, EXTERNAL_INFO_TYPE } from '@wix/pro-gallery-info-element';
import "./gallery.scss";
export var WixProGallery = function (_a) {
    var id = _a.id, itemsSrc = _a.itemsSrc, container = _a.container, styles = _a.styles, isMobile = _a.isMobile, deviceType = _a.deviceType, viewMode = _a.viewMode, setLayoutHeightImp = _a.setLayoutHeightImp, staticMediaUrls = _a.staticMediaUrls, // TODO, these replace the hardcoded wixstatic urls. they should be provided by the platform.
    props = __rest(_a, ["id", "itemsSrc", "container", "styles", "isMobile", "deviceType", "viewMode", "setLayoutHeightImp", "staticMediaUrls"]);
    var _b = useState(processItems(converItemsToProGalleryItems(props.items, itemsSrc)).items), itemsToRender = _b[0], setItemsToRender = _b[1];
    var _c = useState(-1), fullscreenIdx = _c[0], setFullscreenIdx = _c[1];
    useEffect(function () {
        var result = processItems(converItemsToProGalleryItems(props.items || [], itemsSrc));
        var shouldFetchVideoUtlsFromVideoSDK = result.shouldGetVideoUrls;
        setItemsToRender(result.items);
        if (shouldFetchVideoUtlsFromVideoSDK) {
            callServerToGetUrls({ newItems: converItemsToProGalleryItems(props.items, itemsSrc) }, setItemsToRender);
        }
    }, [props.items]);
    var convertedOptions = optionsConverter(styles).galleryOptions;
    var migratedOptions = extendNestedOptionsToIncludeOldAndNew(convertedOptions);
    var options = processLayouts(addPresetOptions(migratedOptions), true);
    var isUnKnownContainer = (function () {
        var _a = container || {}, width = _a.width, height = _a.height, isDefaultContainer = _a.isDefaultContainer;
        var scrollDirection = options.scrollDirection;
        var isMissingWidth = typeof width !== 'number';
        var isMissingHeight = typeof height !== 'number';
        return (isDefaultContainer ||
            isMissingWidth ||
            (scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL &&
                isMissingHeight));
    })();
    var isPrerenderMode = (function () {
        var isSEO = viewMode === GALLERY_CONSTS.viewMode.SEO;
        return isUnKnownContainer && !isSEO;
    })();
    var handleNewGalleryStructure = function (newGalleryStructureData) {
        // TODO when this is ready - take it outside of this file
        var numOfItems = newGalleryStructureData.numOfItems, galleryContainer = newGalleryStructureData.container, galleryOptions = newGalleryStructureData.options, layoutHeight = newGalleryStructureData.layoutHeight, isInfinite = newGalleryStructureData.isInfinite, updatedHeight = newGalleryStructureData.updatedHeight;
        var setHeightImp = function (newHeight) {
            console.log('native pg is setting its own height to:', newHeight);
            if (typeof setLayoutHeightImp === 'function') {
                setLayoutHeightImp(newHeight);
            }
        };
        // TBD check offsetTop
        TPADimensionsHelper.setWixHeight({
            height: layoutHeight,
            offsetTop: 0,
            styleParams: galleryOptions,
            container: galleryContainer,
            numOfItems: numOfItems,
            isInfinite: isInfinite,
            updatedHeight: updatedHeight,
            setHeightImp: setHeightImp,
            viewMode: viewMode === 'EDIT' ? 'editor' : viewMode,
            clearHeight: undefined,
        });
    };
    container = !isUnKnownContainer
        ? container
        : {
            width: isMobile ? 320 : 980,
            height: 800,
        };
    var eventsListener = function (eventName, eventData) {
        switch (eventName) {
            case 'GALLERY_CHANGE':
                handleNewGalleryStructure(eventData);
                break;
            case GALLERY_CONSTS.events.ITEM_ACTION_TRIGGERED:
                handleItemActionTriggered(eventData);
                break;
            default:
                break;
        }
        if (typeof props.eventsListener === 'function') {
            props.eventsListener(eventName, eventData);
        }
    };
    var handleItemActionTriggered = function (eventData) {
        if (eventData.options.behaviourParams.item.clickAction === 'ACTION') {
            setFullscreenIdx(eventData.idx);
        }
    };
    var renderFullscreen = function () {
        return fullscreenIdx >= 0 ?
            React.createElement(FullscreenWrapper, { deviceType: deviceType, items: itemsToRender, options: styles, createMediaUrl: getResizeMediaUrl, staticMediaUrls: staticMediaUrls, setFullscreenIdx: setFullscreenIdx, fullscreenIdx: fullscreenIdx, viewMode: viewMode }) : null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pro-gallery-wix-wrapper" },
            React.createElement(ProGallery, __assign({}, __assign(__assign({}, props), { id: id,
                options: options,
                container: container, createMediaUrl: getResizeMediaUrl(staticMediaUrls), totalItemsCount: itemsToRender.length, items: itemsToRender, eventsListener: eventsListener,
                isPrerenderMode: isPrerenderMode, customComponents: {
                    customInfoRenderer: function (pgItemProps, _placement) { return (React.createElement(InfoElement, __assign({ infoType: EXTERNAL_INFO_TYPE.EXTERNAL }, pgItemProps))); },
                    customHoverRenderer: function (pgItemProps, _placement) { return (React.createElement(InfoElement, __assign({ infoType: EXTERNAL_INFO_TYPE.HOVER }, pgItemProps))); },
                } }))),
            React.createElement(LayoutFixer, __assign({ id: id }, {
                items: itemsToRender,
                options: options,
                isPrerenderMode: isPrerenderMode,
            })),
            renderFullscreen())));
};
//# sourceMappingURL=gallery.js.map